(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["complete-kit"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('complete-kit')) {
    class CompleteKit extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.status = this.querySelector('[data-kit-status]');

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => this.onTabKeydown(event, index));
        });

        this.panels.forEach((panel) => this.initCarousel(panel));

        this.addEventListener('click', (event) => {
          const swatch = event.target.closest('.kit__swatch');
          if (swatch && this.contains(swatch)) {
            this.selectSwatch(swatch);
            return;
          }
          const button = event.target.closest('.kit__add');
          if (button && this.contains(button)) this.addToCart(button);
        });
      }

      onTabKeydown(event, index) {
        const last = this.tabs.length - 1;
        let next = null;
        if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
        if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = last;
        if (next === null) return;
        event.preventDefault();
        this.select(next);
        this.tabs[next].focus();
      }

      select(index) {
        this.tabs.forEach((tab, i) => {
          const active = i === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach((panel, i) => {
          panel.hidden = i !== index;
          if (i === index && panel.kitUpdateArrows) {
            const track = panel.querySelector('.kit__track');
            if (track) track.scrollLeft = 0;
            panel.kitUpdateArrows();
          }
        });
      }

      initCarousel(panel) {
        const track = panel.querySelector('.kit__track');
        const prev = panel.querySelector('.kit__arrow--prev');
        const next = panel.querySelector('.kit__arrow--next');
        if (!track || !prev || !next) return;

        const update = () => {
          const max = track.scrollWidth - track.clientWidth - 2;
          prev.hidden = track.scrollLeft <= 2;
          next.hidden = max <= 0 || track.scrollLeft >= max;
        };
        // arrows page through a full set of visible cards
        // move by the number of fully visible cards, so the peeking card becomes the first one
        const step = () => {
          const card = track.querySelector('.kit__card');
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          if (!card) return track.clientWidth;
          const unit = card.getBoundingClientRect().width + gap;
          return Math.max(1, Math.floor((track.clientWidth + gap) / unit)) * unit;
        };

        prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
        next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
        track.addEventListener('scroll', update, { passive: true });
        if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);

        panel.kitUpdateArrows = update;
        update();
      }

      selectSwatch(swatch) {
        const card = swatch.closest('.kit__card');
        if (!card) return;

        card.querySelectorAll('.kit__swatch').forEach((s) => {
          const on = s === swatch;
          s.classList.toggle('is-selected', on);
          s.setAttribute('aria-pressed', String(on));
        });

        const add = card.querySelector('.kit__add');
        if (add) {
          add.dataset.variantId = swatch.dataset.variantId;
          add.disabled = swatch.dataset.available !== 'true';
          add.classList.remove('is-added');
        }

        const amount = card.querySelector('.kit__amount');
        if (amount) amount.textContent = swatch.dataset.price;

        const price = card.querySelector('.kit__price');
        let compare = card.querySelector('.kit__compare');
        if (swatch.dataset.compare) {
          if (!compare && price) {
            compare = document.createElement('s');
            compare.className = 'kit__compare';
            price.append(compare);
          }
          if (compare) compare.textContent = swatch.dataset.compare;
        } else if (compare) {
          compare.remove();
        }

        card.querySelectorAll('.kit__media, .kit__title').forEach((link) => {
          link.href = swatch.dataset.url;
        });

        const img = card.querySelector('.kit__media img');
        if (img && swatch.dataset.src) {
          if (swatch.dataset.srcset) img.srcset = swatch.dataset.srcset;
          img.src = swatch.dataset.src;
        }
      }

      async addToCart(button) {
        if (button.getAttribute('aria-busy') === 'true') return;
        button.setAttribute('aria-busy', 'true');
        this.announce('');

        const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
          .map((el) => el.dataset.sectionId)
          .filter(Boolean);

        const body = { items: [{ id: Number(button.dataset.variantId), quantity: 1 }] };
        if (sectionIds.length) body.sections = sectionIds.join(',');

        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          });
          const data = await response.json();
          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || 'Could not add this item to the cart.');
          }

          if (this.dataset.redirect === 'true') {
            window.location.href = this.dataset.cartUrl;
            return;
          }

          const cart = await fetch(`${this.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
          await this.notifyTheme({
            source: 'complete-kit',
            itemCount: cart.item_count,
            productId: button.dataset.productId,
            sections: data.sections,
          });

          button.classList.add('is-added');
          this.announce('Added to cart');
          setTimeout(() => button.classList.remove('is-added'), 2000);
        } catch (error) {
          console.error(error);
          this.announce(error.message);
        } finally {
          button.removeAttribute('aria-busy');
        }
      }

      async notifyTheme(data) {
        try {
          const { CartAddEvent } = await import('@theme/events');
          this.dispatchEvent(new CartAddEvent({}, 'complete-kit', data));
        } catch (e) {
          const event = new Event('cart:update', { bubbles: true });
          event.detail = { resource: {}, sourceId: 'complete-kit', data };
          this.dispatchEvent(event);
        }
      }

      announce(message) {
        if (this.status) this.status.textContent = message;
      }
    }

    customElements.define('complete-kit', CompleteKit);
  }
  } catch(e) { console.error(e); }
})();

})();
